import MobileTabSwitcher from "@components/switcher/MobileTabSwitcher";
import AddInstitution from "../../instituitional-management/AddInstitution";
import CurrentInstitutions from "../../instituitional-management/CurrentInstitutions";

const MobileInstitutionalManagement = () => {
  const tabs = [
    { label: "CURRENT INSTITUTIONS", component: <CurrentInstitutions /> },
    {
      label: "ADD A INSTITUTION",
      component: <AddInstitution />,
    },
  ];
  return (
    <div
      className="flex flex-col w-full"
      style={{ height: "calc(100dvh - 56px)" }}
    >
      <div className="h-[56px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 px-4 w-full shrink-0">
        <p className="flex text-text-base text-[14px] font-semibold items-center">
          Institution Management
        </p>
      </div>
      <div className="flex flex-col w-full px-3 mt-4 flex-1 min-h-0">
        <MobileTabSwitcher tabs={tabs} />
      </div>
    </div>
  );
};

export default MobileInstitutionalManagement;
